export const auroraZaps = [];
